import 'moment';
import _, { isEmpty, sortBy } from 'lodash';

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

/** @format */
var feedsCloudFunctions = function feedsCloudFunctions(Firebase) {
  var functions = Firebase.functions;
  return {
    loadFeed: function () {
      var _loadFeed = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(feedTypeUuid, start, filters) {
        var feedMode,
            callableFn,
            props,
            result,
            _args = arguments;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                feedMode = _args.length > 3 && _args[3] !== undefined ? _args[3] : false;
                callableFn = functions.httpsCallable("backendFeedsLoadFeed");
                props = _objectSpread2({
                  return_feed: feedMode,
                  feedTypeUuid: feedTypeUuid
                }, filters);

                if (start !== null) {
                  props.start = start;
                }

                _context.next = 6;
                return callableFn(props);

              case 6:
                result = _context.sent;
                return _context.abrupt("return", result.data);

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function loadFeed(_x, _x2, _x3) {
        return _loadFeed.apply(this, arguments);
      }

      return loadFeed;
    }(),
    searchInFeed: function () {
      var _searchInFeed = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(feedTypeUuid, searchFeedTypeUuid, searchTerms, start) {
        var result;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return functions.httpsCallable("backendFeedsSearchInFeed")({
                  feedTypeUuid: feedTypeUuid,
                  searchFeedTypeUuid: searchFeedTypeUuid,
                  searchTerms: searchTerms,
                  start: start
                });

              case 2:
                result = _context2.sent;
                return _context2.abrupt("return", result.data);

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function searchInFeed(_x4, _x5, _x6, _x7) {
        return _searchInFeed.apply(this, arguments);
      }

      return searchInFeed;
    }()
  };
};

var isRequestSuccess = function isRequestSuccess(response) {
  if (!response) {
    return false;
  }

  return (response === null || response === void 0 ? void 0 : response.status) >= 200 && (response === null || response === void 0 ? void 0 : response.status) < 300;
};

var actionsPrefix$2 = "feeds";
var FETCH_FEED = "".concat(actionsPrefix$2, "/FETCH_FEED");
var FETCH_FEED_COMPLETE = "".concat(actionsPrefix$2, "/FETCH_FEED_COMPLETE");
var UPDATE_FEED_FILTERS = "".concat(actionsPrefix$2, "/UPDATE_FEED_FILTERS");

var FeedsActions = function FeedsActions(Firebase) {
  var cloudFunctions = feedsCloudFunctions(Firebase);

  var fetchFeed = function fetchFeed(feedTypeUuid, refreshMode) {
    return /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch, getState) {
        var _targetFeed$feed, continueFeed, targetFeed, filters, results, _results$store;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                if (feedTypeUuid) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return");

              case 3:
                continueFeed = refreshMode;
                targetFeed = getState().feeds.feedList[feedTypeUuid];

                if (!(targetFeed !== null && targetFeed !== void 0 && (_targetFeed$feed = targetFeed.feed) !== null && _targetFeed$feed !== void 0 && _targetFeed$feed.length)) {
                  continueFeed = false;
                }

                if (!(!(targetFeed !== null && targetFeed !== void 0 && targetFeed.isProcessing) && (!(targetFeed !== null && targetFeed !== void 0 && targetFeed.eof) && continueFeed || !continueFeed))) {
                  _context.next = 17;
                  break;
                }

                dispatch({
                  type: FETCH_FEED,
                  feedTypeUuid: feedTypeUuid,
                  clearFeed: !continueFeed
                });
                filters = getState().feeds.filters[feedTypeUuid] || {};
                _context.next = 11;
                return cloudFunctions.loadFeed(feedTypeUuid, continueFeed, filters, true);

              case 11:
                results = _context.sent;

                if (!isRequestSuccess(results)) {
                  _context.next = 16;
                  break;
                }

                dispatch({
                  type: FETCH_FEED_COMPLETE,
                  payload: results === null || results === void 0 ? void 0 : results.store,
                  feedTypeUuid: feedTypeUuid
                });
                _context.next = 17;
                break;

              case 16:
                throw results === null || results === void 0 ? void 0 : (_results$store = results.store) === null || _results$store === void 0 ? void 0 : _results$store.error;

              case 17:
                _context.next = 22;
                break;

              case 19:
                _context.prev = 19;
                _context.t0 = _context["catch"](0);
                dispatch({
                  type: FETCH_FEED_COMPLETE,
                  error: _context.t0,
                  message: _context.t0.message,
                  feedTypeUuid: feedTypeUuid,
                  payload: {
                    feed: [],
                    is_eof: true
                  }
                });

              case 22:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 19]]);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }();
  };

  var updateFeedFilter = function updateFeedFilter(feedTypeUuid, filters) {
    var runFetch = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    return /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch) {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                dispatch({
                  type: UPDATE_FEED_FILTERS,
                  feedTypeUuid: feedTypeUuid,
                  filters: filters
                });

                if (runFetch) {
                  dispatch(fetchFeed(feedTypeUuid));
                }

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x3) {
        return _ref2.apply(this, arguments);
      };
    }();
  };

  return {
    fetchFeed: fetchFeed,
    updateFeedFilter: updateFeedFilter
  };
};

var topicCloudFunctions = function topicCloudFunctions(Firebase) {
  var functions = Firebase.functions;
  return {
    toggleTopicFollow: function () {
      var _toggleTopicFollow = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(data) {
        var result;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return functions.httpsCallable("backendTopicToggleFollow")(data);

              case 2:
                result = _context.sent;
                return _context.abrupt("return", result.data);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function toggleTopicFollow(_x) {
        return _toggleTopicFollow.apply(this, arguments);
      }

      return toggleTopicFollow;
    }(),
    // Accepts an array of topics to follow
    toggleFollowTopics: function () {
      var _toggleFollowTopics = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(data) {
        var result;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return functions.httpsCallable("backendTopicFollowTopics")(data);

              case 2:
                result = _context2.sent;
                return _context2.abrupt("return", result.data);

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function toggleFollowTopics(_x2) {
        return _toggleFollowTopics.apply(this, arguments);
      }

      return toggleFollowTopics;
    }()
  };
};

var DB_CONSTANTS = {
  CASE_MEDIA: "caseMediaDB",
  CASES: "casesDB",
  COMMENTS: "commentsDB",
  MESH_TERMS: "meshTermsDB",
  PUBLICATIONS: "publicationsDB",
  USERS: "usersDB",
  USER_ROLES: "userRolesDB",
  ASSIGNMENTS: "clientAssignmentDB",
  REVIEW_MESH_TERMS: "reviewMeshTermsDB",
  SAVED_CASES: "userSavedCasesDB",
  USER_DRAFTS: "userDraftsDB",
  REFERENCE_DATA: "referenceData",
  CASE_FILTERS: "caseFilters",
  COMMON: "common",
  COUNTRIES: "countries",
  COUNTRY_SUBDIVISION: "subdivisions",
  SPECIALTIES: "specialties",
  PLATFORMS: "platforms",
  CASES_V2: "casesDBv2",
  MODERATION: "moderationDB",
  VERIFICATION_TAGS: "verificationTags",
  SCHOOLS: "schools",
  CONFIGURATION: "configurationDB",
  DEFAULT_CONFIG: "DEFAULT",
  ELASTIC_CONFIG: "elasticsearchConfig",
  LABELS: "labels",
  ADMIN_USER_CASE_LOCKS: "adminUserCaseLocksDB",
  USER_ACTIVITY_RECORD: "userActivityRecordDB",
  USER_FEED: "userFeedDB",
  USER_COMMUNICATION_PREFS: "userCommunicationPrefsDB",
  USERS_PROFILE: "usersProfileDB",
  USER_VOTES: "userVotesDB",
  USER_CME: "userCmeDB"
};

var REFERENCE_DOCUMENT = "topics";

var topicDB = function topicDB(Firebase) {
  var getCollectionRef = Firebase.getCollectionRef;
  return {
    fetchAll: function () {
      var _fetchAll = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var doc;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return getCollectionRef(DB_CONSTANTS.REFERENCE_DATA).doc(REFERENCE_DOCUMENT).get();

              case 3:
                doc = _context.sent;

                if (!doc.exists) {
                  _context.next = 6;
                  break;
                }

                return _context.abrupt("return", doc.data());

              case 6:
                return _context.abrupt("return", {});

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](0);
                throw new Error("There was an error fetching topics: ".concat(_context.t0.message));

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 9]]);
      }));

      function fetchAll() {
        return _fetchAll.apply(this, arguments);
      }

      return fetchAll;
    }()
  };
};

var actionsPrefix$1 = "topics";
var FETCH_TOPICS = "".concat(actionsPrefix$1, "/Fetch_TOPICS");
var FETCH_TOPICS_COMPLETE = "".concat(actionsPrefix$1, "/Fetch_TOPICS_COMPLETE");
var FOLLOW_TOPIC = "".concat(actionsPrefix$1, "/FOLLOW_TOPIC");
var FOLLOW_TOPIC_ERROR = "".concat(actionsPrefix$1, "/FOLLOW_TOPIC_ERROR");
var FOLLOW_TOPIC_COMPLETE = "".concat(actionsPrefix$1, "/FOLLOW_TOPIC_COMPLETE");

var TopicActions = function TopicActions(Firebase) {
  var cloudFunctions = topicCloudFunctions(Firebase);
  var db = topicDB(Firebase);
  return {
    fetchTopicsIfNeeded: function fetchTopicsIfNeeded() {
      return /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch, getState) {
          var _getState, _getState$topics;

          var topics;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  topics = (_getState = getState()) === null || _getState === void 0 ? void 0 : (_getState$topics = _getState.topics) === null || _getState$topics === void 0 ? void 0 : _getState$topics.data;

                  if (_.isEmpty(topics)) {
                    dispatch(fetchTopics());
                  }

                  return _context.abrupt("return");

                case 3:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x, _x2) {
          return _ref.apply(this, arguments);
        };
      }();
    },
    fetchTopics: function fetchTopics() {
      return /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch) {
          var response, topics;
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  dispatch({
                    type: FETCH_TOPICS
                  });
                  _context2.prev = 1;
                  _context2.next = 4;
                  return db.fetchAll();

                case 4:
                  response = _context2.sent;

                  if (!_.isEmpty(response.all)) {
                    topics = response.all;
                    topics.sort(function (a, b) {
                      return a.displayOrder - b.displayOrder;
                    });
                    dispatch({
                      type: FETCH_TOPICS_COMPLETE,
                      data: topics
                    });
                  } else {
                    dispatch({
                      type: FETCH_TOPICS_COMPLETE,
                      error: true,
                      message: "Failed to fetch topics"
                    });
                  }

                  _context2.next = 11;
                  break;

                case 8:
                  _context2.prev = 8;
                  _context2.t0 = _context2["catch"](1);
                  dispatch({
                    type: FETCH_TOPICS_COMPLETE,
                    error: true,
                    message: _context2.t0.message
                  });

                case 11:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, null, [[1, 8]]);
        }));

        return function (_x3) {
          return _ref2.apply(this, arguments);
        };
      }();
    },
    toggleTopicFollow: function toggleTopicFollow(topicId) {
      // optimistically update follow state before api call
      // revert state if error occurs
      return /*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(dispatch, getState) {
          var selected, follow, newMap, response;
          return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  selected = getState().topics.selected;
                  follow = !selected[topicId];
                  newMap = _objectSpread2(_objectSpread2({}, selected), {}, _defineProperty({}, topicId, follow));
                  dispatch({
                    type: FOLLOW_TOPIC,
                    selected: newMap
                  });
                  _context3.prev = 4;
                  _context3.next = 7;
                  return cloudFunctions.toggleTopicFollow({
                    uuid: topicId,
                    action: follow ? "follow" : "unfollow"
                  });

                case 7:
                  response = _context3.sent;

                  if (!(response.status !== 200)) {
                    _context3.next = 10;
                    break;
                  }

                  return _context3.abrupt("return", dispatch({
                    type: FOLLOW_TOPIC_ERROR,
                    message: "Failed to update follow state for topic ".concat(topicId),
                    selected: selected
                  }));

                case 10:
                  return _context3.abrupt("return", {
                    status: 200
                  });

                case 13:
                  _context3.prev = 13;
                  _context3.t0 = _context3["catch"](4);
                  return _context3.abrupt("return", dispatch({
                    type: FOLLOW_TOPIC_ERROR,
                    message: _context3.t0.message,
                    selected: selected
                  }));

                case 16:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3, null, [[4, 13]]);
        }));

        return function (_x4, _x5) {
          return _ref3.apply(this, arguments);
        };
      }();
    }
  };
};

var ipInfoFunctions = function ipInfoFunctions(AppConfig) {
  return {
    checkIpCountry: function () {
      var _checkIpCountry = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var url, response;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                url = "".concat(BASE_URL).concat(AppConfig.ipinfo);
                _context.next = 4;
                return fetch(url, {
                  method: "GET",
                  headers: {
                    "Content-Type": "application/json"
                  }
                });

              case 4:
                response = _context.sent;

                if (!isRequestSuccess(response)) {
                  _context.next = 9;
                  break;
                }

                return _context.abrupt("return", response === null || response === void 0 ? void 0 : response.json());

              case 9:
                throw new Error("Failed to check country with error: ".concat(response.statusText));

              case 10:
                _context.next = 16;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](0);
                console.log("failed to get ipstack info", _context.t0);
                throw _context.t0;

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 12]]);
      }));

      function checkIpCountry() {
        return _checkIpCountry.apply(this, arguments);
      }

      return checkIpCountry;
    }()
  };
};

/** @format */
var referenceCloudFunctions = function referenceCloudFunctions(Firebase) {
  var functions = Firebase.functions;
  return {
    getPotentialGroupDetails: function () {
      var _getPotentialGroupDetails = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(groupFilterUuid) {
        var callableFn, result;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                callableFn = functions.httpsCallable("backendUserPotentialGroup");
                _context.next = 3;
                return callableFn({
                  groupFilterUuid: groupFilterUuid
                });

              case 3:
                result = _context.sent;
                return _context.abrupt("return", result.data);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function getPotentialGroupDetails(_x) {
        return _getPotentialGroupDetails.apply(this, arguments);
      }

      return getPotentialGroupDetails;
    }()
  };
};

var referenceDB = function referenceDB(Firebase) {
  var getDocRef = Firebase.getDocRef,
      getCollectionRef = Firebase.getCollectionRef;
  return {
    /**
     * Query Firebase for countries data, where each country doc has its regions nested within.
     *
     * Note: Fallback country data. Expect to use elastic search to get country/regions.
     * Use `countriesV2/countries` for app. `countries/countries` is used for admin tools.
     * Using `countriesV2/regions` is an option but fetching is too slow.
     * @returns
     */
    getAllCountriesAndRegions: function () {
      var _getAllCountriesAndRegions = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var col, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return getCollectionRef("".concat(DB_CONSTANTS.REFERENCE_DATA, "/countriesV2/countries")).get();

              case 3:
                col = _context.sent;
                data = [];

                if (!col.empty) {
                  col.docs.forEach(function (doc) {
                    data.push(doc.data());
                  });
                }

                return _context.abrupt("return", data);

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](0);
                console.log("There was an error fetching countries and regions: ", _context.t0.message);
                throw new Error("There was an error fetching countries and regions");

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 9]]);
      }));

      function getAllCountriesAndRegions() {
        return _getAllCountriesAndRegions.apply(this, arguments);
      }

      return getAllCountriesAndRegions;
    }(),
    getProfessions: function () {
      var _getProfessions = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var doc;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return getDocRef("".concat(DB_CONSTANTS.REFERENCE_DATA, "/professions")).get();

              case 3:
                doc = _context2.sent;
                return _context2.abrupt("return", doc.exists ? doc.data() : {});

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2["catch"](0);
                console.log("There was an error fetching professions: ", _context2.t0.message);
                throw new Error("There was an error fetching professions");

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 7]]);
      }));

      function getProfessions() {
        return _getProfessions.apply(this, arguments);
      }

      return getProfessions;
    }(),
    getProfessionSpecialties: function () {
      var _getProfessionSpecialties = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(professionUuid) {
        var collectionSnapshot, professionSpecialties;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return getCollectionRef("".concat(DB_CONSTANTS.REFERENCE_DATA, "/professions/").concat(professionUuid)).get();

              case 3:
                collectionSnapshot = _context3.sent;
                professionSpecialties = [];

                if (!collectionSnapshot.empty) {
                  collectionSnapshot.docs.forEach(function (doc) {
                    professionSpecialties.push(doc.data());
                  });
                }

                return _context3.abrupt("return", professionSpecialties);

              case 9:
                _context3.prev = 9;
                _context3.t0 = _context3["catch"](0);
                console.log("There was an error fetching profession specialties: ", _context3.t0.message);
                throw new Error("There was an error fetching professions specialties");

              case 13:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[0, 9]]);
      }));

      function getProfessionSpecialties(_x) {
        return _getProfessionSpecialties.apply(this, arguments);
      }

      return getProfessionSpecialties;
    }(),
    getInterests: function () {
      var _getInterests = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var docSnapshot;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return getDocRef("".concat(DB_CONSTANTS.REFERENCE_DATA, "/interests")).get();

              case 3:
                docSnapshot = _context4.sent;
                return _context4.abrupt("return", docSnapshot.exists ? docSnapshot.data() : {});

              case 7:
                _context4.prev = 7;
                _context4.t0 = _context4["catch"](0);
                console.log("There was an error fetching interests: ", _context4.t0.message);
                throw new Error("There was an error fetching interests");

              case 11:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[0, 7]]);
      }));

      function getInterests() {
        return _getInterests.apply(this, arguments);
      }

      return getInterests;
    }(),
    getPreviewFeed: function () {
      var _getPreviewFeed = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(_ref) {
        var feedTypeUuid, limit, snapshot, feed;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                feedTypeUuid = _ref.feedTypeUuid, limit = _ref.limit;
                _context5.prev = 1;
                _context5.next = 4;
                return getCollectionRef("".concat(DB_CONSTANTS.REFERENCE_DATA, "/feeds/").concat(feedTypeUuid)).limit(limit).get();

              case 4:
                snapshot = _context5.sent;
                feed = [];

                if (!snapshot.empty) {
                  snapshot.docs.forEach(function (doc) {
                    feed.push(doc.data());
                  });
                }

                return _context5.abrupt("return", feed);

              case 10:
                _context5.prev = 10;
                _context5.t0 = _context5["catch"](1);
                console.log("There was an error fetching preview feed: " + feedTypeUuid, _context5.t0.message);
                throw new Error("There was an error fetching preview feed: " + feedTypeUuid);

              case 14:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, null, [[1, 10]]);
      }));

      function getPreviewFeed(_x2) {
        return _getPreviewFeed.apply(this, arguments);
      }

      return getPreviewFeed;
    }(),
    getPreviewFeedMeta: function () {
      var _getPreviewFeedMeta = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var _docSnapshot$data, docSnapshot;

        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                _context6.next = 3;
                return getDocRef("".concat(DB_CONSTANTS.REFERENCE_DATA, "/feeds")).get();

              case 3:
                docSnapshot = _context6.sent;
                return _context6.abrupt("return", docSnapshot.exists ? (_docSnapshot$data = docSnapshot.data()) === null || _docSnapshot$data === void 0 ? void 0 : _docSnapshot$data.all : {});

              case 7:
                _context6.prev = 7;
                _context6.t0 = _context6["catch"](0);
                console.log("There was an error fetching preview feeds: ", _context6.t0.message);
                throw new Error("There was an error fetching preview feeds");

              case 11:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, null, [[0, 7]]);
      }));

      function getPreviewFeedMeta() {
        return _getPreviewFeedMeta.apply(this, arguments);
      }

      return getPreviewFeedMeta;
    }(),
    getGroups: function () {
      var _getGroups = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var docSnapshot;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;
                _context7.next = 3;
                return getDocRef("".concat(DB_CONSTANTS.REFERENCE_DATA, "/groups")).get();

              case 3:
                docSnapshot = _context7.sent;
                return _context7.abrupt("return", docSnapshot.exists ? docSnapshot.data() : {});

              case 7:
                _context7.prev = 7;
                _context7.t0 = _context7["catch"](0);
                console.log("There was an error fetching groups: ", _context7.t0.message);
                throw new Error("There was an error fetching groups");

              case 11:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, null, [[0, 7]]);
      }));

      function getGroups() {
        return _getGroups.apply(this, arguments);
      }

      return getGroups;
    }()
  };
};

var actionsPrefix = "reference";
var FETCH_FALLBACK_LOCATIONS = "".concat(actionsPrefix, "/FETCH_FALLBACK_LOCATIONS");
var FETCH_FALLBACK_LOCATIONS_COMPLETE = "".concat(actionsPrefix, "/FETCH_FALLBACK_LOCATIONS_COMPLETE");
var FETCH_PROFESSIONS = "".concat(actionsPrefix, "/FETCH_PROFESSIONS");
var FETCH_PROFESSIONS_COMPLETE = "".concat(actionsPrefix, "/FETCH_PROFESSIONS_COMPLETE");
var FETCH_PROFESSIONS_ERROR = "".concat(actionsPrefix, "/FETCH_PROFESSIONS_ERROR");
var FETCH_PROFESSION_SPECIALTIES = "".concat(actionsPrefix, "/FETCH_PROFESSION_SPECIALTIES");
var FETCH_PROFESSION_SPECIALTIES_COMPLETE = "".concat(actionsPrefix, "/FETCH_PROFESSION_SPECIALTIES_COMPLETE");
var FETCH_PROFESSION_SPECIALTIES_ERROR = "".concat(actionsPrefix, "/FETCH_PROFESSION_SPECIALTIES_ERROR");
var FETCH_INTERESTS = "".concat(actionsPrefix, "/FETCH_INTERESTS");
var FETCH_INTERESTS_COMPLETE = "".concat(actionsPrefix, "/FETCH_INTERESTS_COMPLETE");
var FETCH_INTERESTS_ERROR = "".concat(actionsPrefix, "/FETCH_INTERESTS_ERROR");
var FETCH_PREVIEW_FEED = "".concat(actionsPrefix, "/FETCH_PREVIEW_FEED");
var FETCH_PREVIEW_FEED_COMPLETE = "".concat(actionsPrefix, "/FETCH_PREVIEW_FEED_COMPLETE");
var FETCH_COUNTRY_COMPLETE = "".concat(actionsPrefix, "/FETCH_COUNTRY_COMPLETE");
var FETCH_PREVIEW_FEED_META = "".concat(actionsPrefix, "/FETCH_PREVIEW_FEED_META");
var FETCH_PREVIEW_FEED_META_COMPLETE = "".concat(actionsPrefix, "/FETCH_PREVIEW_FEED_META_COMPLETE");
var FETCH_POTENTIAL_GROUP_DETAILS = "".concat(actionsPrefix, "/FETCH_POTENTIAL_GROUP_DETAILS");
var FETCH_POTENTIAL_GROUP_DETAILS_COMPLETE = "".concat(actionsPrefix, "/FETCH_POTENTIAL_GROUP_DETAILS_COMPLETE");

var ReferenceActions = function ReferenceActions(Firebase, AppConfig) {
  var _ipInfoFunctions = ipInfoFunctions(AppConfig),
      checkIpCountry = _ipInfoFunctions.checkIpCountry;

  var db = referenceDB(Firebase);
  var cloudFunctions = referenceCloudFunctions(Firebase);
  /**
   * This is meant only as fallback for country data. Expect
   * to use elastic search for this.
   */

  var fetchFallbackLocationsIfNeeded = function fetchFallbackLocationsIfNeeded() {
    return /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch, getState) {
        var _getState, _getState$references, fallbackLocations, countriesAndRegions;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                fallbackLocations = (_getState = getState()) === null || _getState === void 0 ? void 0 : (_getState$references = _getState.references) === null || _getState$references === void 0 ? void 0 : _getState$references.fallbackLocations;

                if (!(fallbackLocations.isLoadingFallbackLocations || !isEmpty(fallbackLocations.countries) && !isEmpty(fallbackLocations.regions))) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return");

              case 4:
                dispatch({
                  type: FETCH_FALLBACK_LOCATIONS
                });
                _context.next = 7;
                return db.getAllCountriesAndRegions();

              case 7:
                countriesAndRegions = _context.sent;
                dispatch({
                  type: FETCH_FALLBACK_LOCATIONS_COMPLETE,
                  payload: {
                    countriesAndRegions: countriesAndRegions
                  }
                });
                _context.next = 14;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](0);
                console.log("fetchFallbackLocationsIfNeeded failed: ", _context.t0.message);

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 11]]);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }();
  };

  var fetchProfessionsIfNeeded = function fetchProfessionsIfNeeded() {
    return /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch, getState) {
        var _getState2, _getState2$references, result;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                if (isEmpty((_getState2 = getState()) === null || _getState2 === void 0 ? void 0 : (_getState2$references = _getState2.references) === null || _getState2$references === void 0 ? void 0 : _getState2$references.professions)) {
                  _context2.next = 3;
                  break;
                }

                return _context2.abrupt("return");

              case 3:
                dispatch({
                  type: FETCH_PROFESSIONS
                });
                _context2.next = 6;
                return db.getProfessions();

              case 6:
                result = _context2.sent;
                dispatch({
                  type: FETCH_PROFESSIONS_COMPLETE,
                  payload: {
                    professions: result
                  }
                });
                _context2.next = 13;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2["catch"](0);
                dispatch({
                  type: FETCH_PROFESSIONS_ERROR,
                  payload: {
                    error: _context2.t0
                  }
                });

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 10]]);
      }));

      return function (_x3, _x4) {
        return _ref2.apply(this, arguments);
      };
    }();
  };

  var fetchProfessionSpecialtiesIfNeeded = function fetchProfessionSpecialtiesIfNeeded(professionUuid) {
    return /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(dispatch, getState) {
        var _getState3, _getState3$references, _getState3$references2, professionSpecialties;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;

                if (!((_getState3 = getState()) !== null && _getState3 !== void 0 && (_getState3$references = _getState3.references) !== null && _getState3$references !== void 0 && (_getState3$references2 = _getState3$references.professionSpecialties) !== null && _getState3$references2 !== void 0 && _getState3$references2[professionUuid] || !professionUuid)) {
                  _context3.next = 3;
                  break;
                }

                return _context3.abrupt("return");

              case 3:
                dispatch({
                  type: FETCH_PROFESSION_SPECIALTIES
                });
                _context3.next = 6;
                return db.getProfessionSpecialties(professionUuid);

              case 6:
                professionSpecialties = _context3.sent;
                dispatch({
                  type: FETCH_PROFESSION_SPECIALTIES_COMPLETE,
                  payload: {
                    professionUuid: professionUuid,
                    professionSpecialties: professionSpecialties
                  }
                });
                _context3.next = 13;
                break;

              case 10:
                _context3.prev = 10;
                _context3.t0 = _context3["catch"](0);
                dispatch({
                  type: FETCH_PROFESSION_SPECIALTIES_ERROR,
                  payload: {
                    error: _context3.t0
                  }
                });

              case 13:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[0, 10]]);
      }));

      return function (_x5, _x6) {
        return _ref3.apply(this, arguments);
      };
    }();
  };

  var fetchInterestsIfNeeded = function fetchInterestsIfNeeded() {
    return /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(dispatch, getState) {
        var _getState4, _getState4$references, result;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;

                if (isEmpty((_getState4 = getState()) === null || _getState4 === void 0 ? void 0 : (_getState4$references = _getState4.references) === null || _getState4$references === void 0 ? void 0 : _getState4$references.interests)) {
                  _context4.next = 3;
                  break;
                }

                return _context4.abrupt("return");

              case 3:
                dispatch({
                  type: FETCH_INTERESTS
                });
                _context4.next = 6;
                return db.getInterests();

              case 6:
                result = _context4.sent;
                dispatch({
                  type: FETCH_INTERESTS_COMPLETE,
                  payload: {
                    interests: result
                  }
                });
                _context4.next = 13;
                break;

              case 10:
                _context4.prev = 10;
                _context4.t0 = _context4["catch"](0);
                dispatch({
                  type: FETCH_INTERESTS_ERROR,
                  payload: {
                    error: _context4.t0
                  }
                });

              case 13:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[0, 10]]);
      }));

      return function (_x7, _x8) {
        return _ref4.apply(this, arguments);
      };
    }();
  };

  var getPreviewFeedIfNeeded = function getPreviewFeedIfNeeded(_ref5) {
    var feedTypeUuid = _ref5.feedTypeUuid,
        _ref5$limit = _ref5.limit,
        limit = _ref5$limit === void 0 ? 100 : _ref5$limit;
    return /*#__PURE__*/function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(dispatch, getState) {
        var _getState5, _getState5$references, _getState5$references2, feed;

        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;

                if (!isEmpty((_getState5 = getState()) === null || _getState5 === void 0 ? void 0 : (_getState5$references = _getState5.references) === null || _getState5$references === void 0 ? void 0 : (_getState5$references2 = _getState5$references.feeds) === null || _getState5$references2 === void 0 ? void 0 : _getState5$references2[feedTypeUuid])) {
                  _context5.next = 7;
                  break;
                }

                dispatch({
                  type: FETCH_PREVIEW_FEED,
                  payload: {
                    feedTypeUuid: feedTypeUuid
                  }
                });
                _context5.next = 5;
                return db.getPreviewFeed({
                  feedTypeUuid: feedTypeUuid,
                  limit: limit
                });

              case 5:
                feed = _context5.sent;
                dispatch({
                  type: FETCH_PREVIEW_FEED_COMPLETE,
                  payload: {
                    feed: feed,
                    feedTypeUuid: feedTypeUuid
                  }
                });

              case 7:
                _context5.next = 12;
                break;

              case 9:
                _context5.prev = 9;
                _context5.t0 = _context5["catch"](0);
                console.log(_context5.t0);

              case 12:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, null, [[0, 9]]);
      }));

      return function (_x9, _x10) {
        return _ref6.apply(this, arguments);
      };
    }();
  };

  var getPreviewFeedMetaIfNeeded = function getPreviewFeedMetaIfNeeded() {
    return /*#__PURE__*/function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(dispatch, getState) {
        var _getState6, _getState6$references, feedsMeta;

        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;

                if (!isEmpty((_getState6 = getState()) === null || _getState6 === void 0 ? void 0 : (_getState6$references = _getState6.references) === null || _getState6$references === void 0 ? void 0 : _getState6$references.feedsMeta)) {
                  _context6.next = 7;
                  break;
                }

                dispatch({
                  type: FETCH_PREVIEW_FEED_META
                });
                _context6.next = 5;
                return db.getPreviewFeedMeta();

              case 5:
                feedsMeta = _context6.sent;
                dispatch({
                  type: FETCH_PREVIEW_FEED_META_COMPLETE,
                  payload: {
                    feedsMeta: feedsMeta
                  }
                });

              case 7:
                _context6.next = 12;
                break;

              case 9:
                _context6.prev = 9;
                _context6.t0 = _context6["catch"](0);
                console.log(_context6.t0);

              case 12:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, null, [[0, 9]]);
      }));

      return function (_x11, _x12) {
        return _ref7.apply(this, arguments);
      };
    }();
  };

  var checkCurrentCountry = function checkCurrentCountry() {
    return /*#__PURE__*/function () {
      var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(dispatch) {
        var _response$country, response;

        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;
                _context7.next = 3;
                return checkIpCountry();

              case 3:
                response = _context7.sent;
                return _context7.abrupt("return", dispatch({
                  type: FETCH_COUNTRY_COMPLETE,
                  payload: {
                    country: response === null || response === void 0 ? void 0 : (_response$country = response.country) === null || _response$country === void 0 ? void 0 : _response$country.toUpperCase()
                  }
                }));

              case 7:
                _context7.prev = 7;
                _context7.t0 = _context7["catch"](0);
                return _context7.abrupt("return", dispatch({
                  type: FETCH_COUNTRY_COMPLETE,
                  payload: {
                    country: "US",
                    error: true,
                    message: _context7.t0.message
                  }
                }));

              case 10:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, null, [[0, 7]]);
      }));

      return function (_x13) {
        return _ref8.apply(this, arguments);
      };
    }();
  };

  var getGroupsInfoIfNeeded = function getGroupsInfoIfNeeded() {
    return /*#__PURE__*/function () {
      var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(dispatch, getState) {
        var _getState7, _getState7$references, groups;

        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.prev = 0;

                if (!isEmpty((_getState7 = getState()) === null || _getState7 === void 0 ? void 0 : (_getState7$references = _getState7.references) === null || _getState7$references === void 0 ? void 0 : _getState7$references.groups)) {
                  _context8.next = 7;
                  break;
                }

                dispatch({
                  type: FETCH_GROUPS
                });
                _context8.next = 5;
                return db.getGroups();

              case 5:
                groups = _context8.sent;
                dispatch({
                  type: FETCH_GROUPS_COMPLETE,
                  payload: {
                    groups: groups
                  }
                });

              case 7:
                _context8.next = 12;
                break;

              case 9:
                _context8.prev = 9;
                _context8.t0 = _context8["catch"](0);
                console.log(_context8.t0);

              case 12:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, null, [[0, 9]]);
      }));

      return function (_x14, _x15) {
        return _ref9.apply(this, arguments);
      };
    }();
  };

  var getPotentialGroupDetails = function getPotentialGroupDetails(groupFilterUuid) {
    return /*#__PURE__*/function () {
      var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(dispatch) {
        var data;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.prev = 0;

                if (groupFilterUuid) {
                  _context9.next = 3;
                  break;
                }

                return _context9.abrupt("return");

              case 3:
                dispatch({
                  type: FETCH_POTENTIAL_GROUP_DETAILS
                });
                _context9.next = 6;
                return cloudFunctions.getPotentialGroupDetails(groupFilterUuid);

              case 6:
                data = _context9.sent;
                dispatch({
                  type: FETCH_POTENTIAL_GROUP_DETAILS_COMPLETE,
                  payload: {
                    potentialGroupDetails: data.store
                  }
                });
                _context9.next = 13;
                break;

              case 10:
                _context9.prev = 10;
                _context9.t0 = _context9["catch"](0);
                console.log(_context9.t0);

              case 13:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, null, [[0, 10]]);
      }));

      return function (_x16) {
        return _ref10.apply(this, arguments);
      };
    }();
  };

  return {
    fetchFallbackLocationsIfNeeded: fetchFallbackLocationsIfNeeded,
    fetchProfessionsIfNeeded: fetchProfessionsIfNeeded,
    fetchProfessionSpecialtiesIfNeeded: fetchProfessionSpecialtiesIfNeeded,
    fetchInterestsIfNeeded: fetchInterestsIfNeeded,
    getPreviewFeedIfNeeded: getPreviewFeedIfNeeded,
    getPreviewFeedMetaIfNeeded: getPreviewFeedMetaIfNeeded,
    checkCurrentCountry: checkCurrentCountry,
    getGroupsInfoIfNeeded: getGroupsInfoIfNeeded,
    getPotentialGroupDetails: getPotentialGroupDetails
  };
};

/** @format */
var groupsCloudFunctions = function groupsCloudFunctions(Firebase) {
  var functions = Firebase.functions;
  return {
    groupModifyMembersCall: function () {
      var _groupModifyMembersCall = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(action, groupUuid, usersUuid) {
        var callableFn, result;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                callableFn = functions.httpsCallable("backendGroupsModifyMembers");
                _context.next = 3;
                return callableFn({
                  action: action,
                  groupUuid: groupUuid,
                  usersUuid: usersUuid
                });

              case 3:
                result = _context.sent;
                return _context.abrupt("return", result.data);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function groupModifyMembersCall(_x, _x2, _x3) {
        return _groupModifyMembersCall.apply(this, arguments);
      }

      return groupModifyMembersCall;
    }()
  };
};

var GroupsActions = function GroupsActions(Firebase) {
  var cloudFunctions = groupsCloudFunctions(Firebase);

  var addMembers = function addMembers(groupUuid, usersUuid) {
    return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var result;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(!groupUuid || usersUuid.length === 0)) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              _context.next = 4;
              return cloudFunctions.groupModifyMembersCall("add_members", groupUuid, usersUuid);

            case 4:
              result = _context.sent;

              if (!isRequestSuccess(result)) {
                _context.next = 7;
                break;
              }

              return _context.abrupt("return", result);

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
  };

  return {
    addMembers: addMembers
  };
};

var actions = function actions(Firebase, AppConfig) {
  return {
    TopicsActions: TopicActions(Firebase),
    FeedsActions: FeedsActions(Firebase),
    ReferenceActions: ReferenceActions(Firebase, AppConfig),
    GroupsActions: GroupsActions(Firebase)
  };
};

var INITIAL_STATE$2 = {
  data: [],
  selected: {},
  isProcessing: false,
  error: false,
  message: null
};

var TopicsReducer = function TopicsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE$2;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case FETCH_TOPICS:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        isProcessing: true
      });

    case FETCH_TOPICS_COMPLETE:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        isProcessing: false,
        error: action.error,
        data: action.data || state.data,
        message: action.message
      });

    case FOLLOW_TOPIC:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        selected: action.selected
      });

    case FOLLOW_TOPIC_ERROR:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        error: true,
        message: action.message,
        selected: action.selected
      });

    case FOLLOW_TOPIC_COMPLETE:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        selected: action.selected
      });

    default:
      return state;
  }
};

var INITIAL_STATE$1 = {
  feedList: {},
  filters: {}
};

var FeedsReducer = function FeedsReducer() {
  var _action$payload, _action$payload2;

  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE$1;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case FETCH_FEED:
      var contents = _objectSpread2(_objectSpread2({}, state.feedList[action.feedTypeUuid]), {}, {
        isProcessing: true
      });

      if (action.clearFeed) {
        contents = _objectSpread2(_objectSpread2({}, state.feedList[action.feedTypeUuid]), {}, {
          feed: [],
          isProcessing: true
        });
      }

      return _objectSpread2(_objectSpread2({}, state), {}, {
        feedList: _objectSpread2(_objectSpread2({}, state.feedList), {}, _defineProperty({}, action.feedTypeUuid, contents))
      });

    case FETCH_FEED_COMPLETE:
      var currentFeed = state.feedList[action.feedTypeUuid];
      return _objectSpread2(_objectSpread2({}, state), {}, {
        feedList: _objectSpread2(_objectSpread2({}, state.feedList), {}, _defineProperty({}, action.feedTypeUuid, _objectSpread2(_objectSpread2({}, currentFeed), {}, {
          feed: [].concat(_toConsumableArray((currentFeed === null || currentFeed === void 0 ? void 0 : currentFeed.feed) || []), _toConsumableArray(((_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.feed) || [])),
          eof: ((_action$payload2 = action.payload) === null || _action$payload2 === void 0 ? void 0 : _action$payload2.is_eof) || false,
          isProcessing: false,
          error: action.error,
          message: action.message
        })))
      });

    case UPDATE_FEED_FILTERS:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        filters: _objectSpread2(_objectSpread2({}, state.filters), {}, _defineProperty({}, action.feedTypeUuid, action.filters))
      });

    default:
      return state;
  }
};

var COUNTRIES = {
  usa: "United States",
  canada: "Canada"
};

var INITIAL_STATE = {
  isLoading: false,
  error: null,
  fallbackLocations: {
    isLoadingFallbackLocations: false,
    countries: [],
    regions: [] // states and provinces

  },
  professions: [],
  professionSpecialties: {},
  interests: [],
  feeds: {},
  feedsMeta: {},
  country: null,
  potentialGroupDetails: {}
};

var referenceReducer = function referenceReducer() {
  var _action$payload, _action$payload4, _action$payload5, _state$feeds$action$p, _action$payload6, _action$payload7;

  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case FETCH_PROFESSIONS:
    case FETCH_PROFESSION_SPECIALTIES:
    case FETCH_INTERESTS:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        isLoading: true
      });

    case FETCH_FALLBACK_LOCATIONS:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        fallbackLocations: _objectSpread2(_objectSpread2({}, state.fallbackLocations), {}, {
          isLoadingFallbackLocations: true
        })
      });

    case FETCH_FALLBACK_LOCATIONS_COMPLETE:
      return formatFallbackLocations(state, action);

    case FETCH_PROFESSIONS_COMPLETE:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        isLoading: false,
        professions: formatProfessions(action.payload.professions)
      });

    case FETCH_PROFESSION_SPECIALTIES_COMPLETE:
      if (action !== null && action !== void 0 && (_action$payload = action.payload) !== null && _action$payload !== void 0 && _action$payload.professionUuid) {
        var _action$payload2, _action$payload3;

        var newSpecialties = _objectSpread2({}, state.professionSpecialties);

        newSpecialties[action === null || action === void 0 ? void 0 : (_action$payload2 = action.payload) === null || _action$payload2 === void 0 ? void 0 : _action$payload2.professionUuid] = action === null || action === void 0 ? void 0 : (_action$payload3 = action.payload) === null || _action$payload3 === void 0 ? void 0 : _action$payload3.professionSpecialties;
        return _objectSpread2(_objectSpread2({}, state), {}, {
          isLoading: false,
          professionSpecialties: _objectSpread2({}, newSpecialties)
        });
      }

      return _objectSpread2(_objectSpread2({}, state), {}, {
        isLoading: false
      });

    case FETCH_INTERESTS_COMPLETE:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        isLoading: false,
        interests: action === null || action === void 0 ? void 0 : (_action$payload4 = action.payload) === null || _action$payload4 === void 0 ? void 0 : _action$payload4.interests
      });

    case FETCH_PROFESSIONS_ERROR:
    case FETCH_PROFESSION_SPECIALTIES_ERROR:
    case FETCH_INTERESTS_ERROR:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        isLoading: false,
        error: action === null || action === void 0 ? void 0 : (_action$payload5 = action.payload) === null || _action$payload5 === void 0 ? void 0 : _action$payload5.error
      });

    case FETCH_PREVIEW_FEED:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        feeds: _objectSpread2(_objectSpread2({}, state.feeds), {}, _defineProperty({}, action.payload.feedTypeUuid, {
          data: (_state$feeds$action$p = state.feeds[action.payload.feedTypeUuid]) === null || _state$feeds$action$p === void 0 ? void 0 : _state$feeds$action$p.data,
          loading: true
        }))
      });

    case FETCH_PREVIEW_FEED_COMPLETE:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        feeds: _objectSpread2(_objectSpread2({}, state.feeds), {}, _defineProperty({}, action.payload.feedTypeUuid, {
          data: action.payload.feed,
          loading: false
        }))
      });

    case FETCH_PREVIEW_FEED_META:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        feedsMeta: _objectSpread2(_objectSpread2({}, state.feedsMeta), {}, {
          data: {},
          loading: true
        })
      });

    case FETCH_PREVIEW_FEED_META_COMPLETE:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        feedsMeta: _objectSpread2(_objectSpread2({}, state.feedsMeta), {}, {
          data: action.payload.feedsMeta,
          loading: false
        })
      });

    case FETCH_COUNTRY_COMPLETE:
      var newProps = {
        country: action === null || action === void 0 ? void 0 : (_action$payload6 = action.payload) === null || _action$payload6 === void 0 ? void 0 : _action$payload6.country
      };

      if (action !== null && action !== void 0 && (_action$payload7 = action.payload) !== null && _action$payload7 !== void 0 && _action$payload7.error) {
        var _action$payload8;

        newProps.error = action === null || action === void 0 ? void 0 : (_action$payload8 = action.payload) === null || _action$payload8 === void 0 ? void 0 : _action$payload8.error;
      }

      return _objectSpread2(_objectSpread2({}, state), newProps);

    case FETCH_GROUPS:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        groups: _objectSpread2(_objectSpread2({}, state.groups), {}, {
          data: {},
          loading: true
        })
      });

    case FETCH_GROUPS_COMPLETE:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        groups: _objectSpread2(_objectSpread2({}, state.groups), {}, {
          data: action.payload.groups,
          loading: false
        })
      });

    case FETCH_POTENTIAL_GROUP_DETAILS:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        potentialGroupDetails: _objectSpread2(_objectSpread2({}, state.potentialGroupDetails), {}, {
          data: {},
          loading: true
        })
      });

    case FETCH_POTENTIAL_GROUP_DETAILS_COMPLETE:
      console.log("action.payload");
      console.log(action.payload);
      return _objectSpread2(_objectSpread2({}, state), {}, {
        potentialGroupDetails: _objectSpread2(_objectSpread2({}, state.potentialGroupDetails), {}, {
          data: action.payload.potentialGroupDetails,
          loading: false
        })
      });

    default:
      return state;
  }
};
/**
 * Separate profession categories and specific professions and format data for picker.
 *
 * Most profession categories are professions, but there are 2 categories that
 * have multiple different specific professions: "Other HCP" and "Other Student".
 *
 * Non "Other" categories (like physician, nurse etc) only have 1 profession, with
 * the same name as its category, while these "Other" categories have multiple
 * different specific professions. Selecting either of these "Other" professions
 * requires further specification of profession.
 */


var formatProfessions = function formatProfessions(professions) {
  var categories = [];
  var specificProfessions = {};
  Object.keys(professions).forEach(function (key) {
    var profession = professions[key];

    if (!categories.some(function (category) {
      return category.value === profession.professionCategoryLabel;
    })) {
      categories.push(_objectSpread2({
        label: profession.professionCategoryName,
        value: profession.professionCategoryLabel,
        displayOrder: profession.displayOrder
      }, profession.hidden && {
        hidden: profession.hidden
      }));
    } // Create a list of specific professions categorized by profession category


    var currentSpecificProfessions = specificProfessions[profession.professionCategoryLabel] || [];
    specificProfessions[profession.professionCategoryLabel] = [].concat(_toConsumableArray(currentSpecificProfessions), [profession]);
  }); // Format and sort specific professions in each category

  Object.keys(specificProfessions).forEach(function (key) {
    var _professions = ((specificProfessions === null || specificProfessions === void 0 ? void 0 : specificProfessions[key]) || []).map(function (p) {
      return {
        label: p.professionName,
        value: p.professionUuid
      };
    });

    specificProfessions[key] = sortBy(_professions, ["label"]);
  });
  return {
    categories: sortBy(categories, ["displayOrder"]),
    specificProfessions: specificProfessions,
    raw: professions,
    isLoadingProfessions: false
  };
};

var formatFallbackLocations = function formatFallbackLocations(state, action) {
  var countriesAndRegions = action.payload.countriesAndRegions;

  var _countriesAndRegions$ = countriesAndRegions.reduce(function (acc, country) {
    var _country$countryRegio;

    acc.countries.push({
      label: country.countryName,
      value: country.countryUuid,
      countryCode: country.countryCode
    });

    if (country !== null && country !== void 0 && (_country$countryRegio = country.countryRegions) !== null && _country$countryRegio !== void 0 && _country$countryRegio.length) {
      country.countryRegions.forEach(function (r) {
        acc.regions.push({
          regionCode: r.regionCode,
          label: r.regionName,
          value: r.regionUuid,
          countryCode: country.countryUuid
        });
      });
    }

    return acc;
  }, {
    countries: [],
    regions: []
  }),
      countries = _countriesAndRegions$.countries,
      regions = _countriesAndRegions$.regions; // sort country by label. Put US first, Canada second.


  countries.sort(function (a, b) {
    var _a$label;

    if (a.label === b.label) return 0;
    if (a.label === COUNTRIES.usa) return -1;
    if (b.label === COUNTRIES.usa) return 1;
    if (a.label === COUNTRIES.canada) return -1;
    if (b.label === COUNTRIES.canada) return 1;
    return (_a$label = a.label) === null || _a$label === void 0 ? void 0 : _a$label.localeCompare(b.label);
  });
  return _objectSpread2(_objectSpread2({}, state), {}, {
    fallbackLocations: _objectSpread2(_objectSpread2({}, state.fallbackLocations), {}, {
      countries: countries,
      regions: sortBy(regions, "label"),
      isLoadingFallbackLocations: false
    })
  });
};

var ReducerStates = {
  FEEDS_INITIAL_STATE: INITIAL_STATE$1,
  TOPICS_INITIAL_STATE: INITIAL_STATE$2,
  REFERENCE_INITIAL_STATE: INITIAL_STATE
};
var reducers = {
  TopicsReducer: TopicsReducer,
  FeedsReducer: FeedsReducer,
  ReferenceReducer: referenceReducer
};

var Actions = actions;
var Reducers = reducers;
var InitialReducerStates = ReducerStates;

export { Actions, InitialReducerStates, Reducers };
